<template>
	<td>
		<div class="money">
			<span>€</span>
			<span>{{ formatNumeric(value, 0, 0) }}</span>
		</div>
	</td>
</template>

<script setup lang="ts">
import { formatNumeric } from "@/helpers/inputHelpers";

defineProps<{
	value: number;
}>();
</script>
